import React from 'react';
import { FormattedMessage } from 'react-intl';

import useWindowSize from '../../hooks/useWindowSize';
// import PropTypes from 'prop-types';
import * as AppPropTypes from '../../lib/PropTypes';

import Button from '../buttons/Button';
import { LiteLeagueCrest } from '../icons/logos';
import OtherLocales from '../partials/OtherLocales';

import styles from '../../../styles/pages/liteleague.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

function LiteleaguePage({ page }) {
    const { height } = useWindowSize();

    const { urls, contests } = page || {};

    return (
        <div className={styles.container} style={{ minHeight: height }}>
            <div className={styles.inner}>
                <div className={styles.welcomeContainer}>
                    <FormattedMessage defaultMessage="Welcome to" description="Welcome text" />
                </div>
                <div className={styles.logoContainer}>
                    <LiteLeagueCrest className={styles.logo} />
                </div>

                <div className={styles.label}>
                    <FormattedMessage defaultMessage="Playing from" description="Buttons label" />
                </div>

                <div className={styles.contests}>
                    {contests.map(({ handle, url }, contestIndex) => (
                        <Button
                            key={`contest-${contestIndex + 1}`}
                            href={url}
                            direct
                            className={styles.contest}
                        >
                            {handle.indexOf('home') !== -1 ? (
                                <FormattedMessage
                                    defaultMessage="Home"
                                    description="Button label"
                                />
                            ) : (
                                <FormattedMessage defaultMessage="Bar" description="Button label" />
                            )}
                        </Button>
                    ))}
                </div>
                <OtherLocales className={styles.otherLocales} pageUrls={urls} />
            </div>
        </div>
    );
}

LiteleaguePage.propTypes = propTypes;

export default LiteleaguePage;
